import IMask from "imask";

export const currencySymbols = {
  crc: "₡",
  usd: "$",
  eur: "€"
};

export default (currency = "usd", scale = 2, padFractionalZeros = false) =>
  IMask.createPipe({
    mask: `${currencySymbols[currency] || ""} num`,
    blocks: {
      num: {
        mask: Number,
        thousandsSeparator: ",",
        signed: false,
        min: -1000000,
        normalizeZeros: false,
        padFractionalZeros,
        radix: ".",
        mapToRadix: ["."],
        scale
      }
    }
  });
